export const territory = [
  "Newfoundland",
  "Northwest Territories",
  "Nova Scotia",
  "Birmingham",
  "New Brunswick",
  "Manitoba",
  "Nunavut",
  "Alberta"
];
